// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_popoverBody__BoP8t {
  width: 20rem;
  border-radius: 3rem;
  max-height: 22rem;
  background-color: rgba(255, 255, 255, 0.5);
  overflow: hidden; }

.styles_popover__\\+gC6j {
  margin-left: 8rem; }

.styles_title__oj2BN {
  font-size: 16px;
  margin-bottom: 12px;
  color: #333; }

.styles_previewContainer__pI571 {
  min-width: 100%;
  max-width: 54vw;
  height: 22rem;
  overflow-y: auto;
  padding: 1rem;
  background-color: transparent; }

.styles_boothsContainer__Ddw\\+I {
  display: flex;
  flex-direction: column;
  max-height: 22rem;
  overflow-y: auto;
  background-color: transparent; }

.styles_boothCard__XFGyU {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #8080801a;
  min-height: 7rem;
  max-height: 7rem;
  width: 18rem;
  overflow: hidden;
  align-items: center;
  display: flex; }
  .styles_boothCard__XFGyU:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-color: #1976d2; }
    .styles_boothCard__XFGyU:hover .styles_actions__IOIVq {
      opacity: 1; }
  .styles_boothCard__XFGyU.styles_focused__-dWdb {
    border: 2px solid #72abab; }

.styles_boothContent__wFxjS {
  padding: 1rem; }

.styles_boothName__GQk-o {
  font-size: 1.2rem;
  font-weight: 600;
  color: #808080e6; }

.styles_boothInfo__XCJCE {
  display: flex;
  align-items: center;
  gap: 1rem; }

.styles_actions__IOIVq {
  display: flex;
  opacity: 0;
  transition: opacity 0.2s ease;
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  margin-left: 1rem; }

.styles_actionIcon__vXXzc {
  cursor: pointer;
  color: #808080b8;
  transition: color 0.5s ease; }
  .styles_actionIcon__vXXzc:hover {
    color: #72abab; }

.styles_previewModal__eWZqJ {
  width: 90vw !important;
  height: 90vh !important;
  max-width: none !important;
  max-height: none !important;
  padding: 0 !important;
  border-radius: 0 !important; }

.styles_previewFrame__by0zh {
  width: 100%;
  height: 100%;
  border: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/ActiveBoothsPreview/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAIA;EACI,YAAY;EACZ,mBAAmB;EACnB,iBAAwC;EACxC,0CAA0C;EAC1C,gBAAgB,EAAA;;AAGpB;EACI,iBAAiB,EAAA;;AAGrB;EACI,eAAe;EACf,mBAAmB;EACnB,WAAW,EAAA;;AAGf;EACI,eAAe;EACf,eAAe;EACf,aAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,6BAA6B,EAAA;;AAGjC;EACI,aAAa;EACb,sBAAsB;EACtB,iBAAwC;EACxC,gBAAgB;EAChB,6BAA6B,EAAA;;AAGjC;EACI,eAAe;EACf,yBAAyB;EACzB,2BC9Bc;ED+Bd,gBAzCmB;EA0CnB,gBA1CmB;EA2CnB,YAAY;EACZ,gBAAgB;EAgBhB,mBAAmB;EACnB,aAAa,EAAA;EAxBjB;IAUQ,2BAA2B;IAC3B,wCAAwC;IACxC,qBClBS,EAAA;IDMjB;MAeY,UAAU,EAAA;EAftB;IAoBQ,yBCpBY,EAAA;;AD2BpB;EACI,aAAa,EAAA;;AAGjB;EACI,iBAAiB;EACjB,gBAAgB;EAChB,gBCvDc,EAAA;;AD0DlB;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAGb;EACI,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,iBAAiB,EAAA;;AAGrB;EACI,eAAe;EACf,gBC/Ec;EDgFd,2BAA2B,EAAA;EAH/B;IAMQ,cC7DY,EAAA;;ADiEpB;EACI,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B,EAAA;;AAG/B;EACI,WAAW;EACX,YAAY;EACZ,YAAY,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n$boothsCardHeight: 7rem;\n\n.popoverBody {\n    width: 20rem;\n    border-radius: 3rem;\n    max-height: $boothsCardHeight * 3 + 1rem;\n    background-color: rgba(255, 255, 255, 0.5);\n    overflow: hidden;\n}\n\n.popover {\n    margin-left: 8rem;\n}\n\n.title {\n    font-size: 16px;\n    margin-bottom: 12px;\n    color: #333;\n}\n\n.previewContainer {\n    min-width: 100%;\n    max-width: 54vw;\n    height: $boothsCardHeight * 3 + 1rem;\n    overflow-y: auto;\n    padding: 1rem;\n    background-color: transparent;\n}\n\n.boothsContainer {\n    display: flex;\n    flex-direction: column;\n    max-height: $boothsCardHeight * 3 + 1rem;\n    overflow-y: auto;\n    background-color: transparent;\n}\n\n.boothCard {\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid $grey10;\n    min-height: $boothsCardHeight;\n    max-height: $boothsCardHeight;\n    width: 18rem;\n    overflow: hidden;\n\n    &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        border-color: $ui_blue;\n\n        .actions {\n            opacity: 1;\n        }\n    }\n\n    &.focused {\n        border: 2px solid $ocean_blue;\n    }\n\n    align-items: center;\n    display: flex;\n}\n\n.boothContent {\n    padding: 1rem;\n}\n\n.boothName {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: $grey90;\n}\n\n.boothInfo {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.actions {\n    display: flex;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    position: absolute;\n    right: 1rem;\n    top: 0.5rem;\n    align-items: center;\n    gap: 0.5rem;\n    margin-left: 1rem;\n}\n\n.actionIcon {\n    cursor: pointer;\n    color: $grey72;\n    transition: color 0.5s ease;\n\n    &:hover {\n        color: $ocean_blue;\n    }\n}\n\n.previewModal {\n    width: 90vw !important;\n    height: 90vh !important;\n    max-width: none !important;\n    max-height: none !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n}\n\n.previewFrame {\n    width: 100%;\n    height: 100%;\n    border: none;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverBody": `styles_popoverBody__BoP8t`,
	"popover": `styles_popover__+gC6j`,
	"title": `styles_title__oj2BN`,
	"previewContainer": `styles_previewContainer__pI571`,
	"boothsContainer": `styles_boothsContainer__Ddw+I`,
	"boothCard": `styles_boothCard__XFGyU`,
	"actions": `styles_actions__IOIVq`,
	"focused": `styles_focused__-dWdb`,
	"boothContent": `styles_boothContent__wFxjS`,
	"boothName": `styles_boothName__GQk-o`,
	"boothInfo": `styles_boothInfo__XCJCE`,
	"actionIcon": `styles_actionIcon__vXXzc`,
	"previewModal": `styles_previewModal__eWZqJ`,
	"previewFrame": `styles_previewFrame__by0zh`
};
export default ___CSS_LOADER_EXPORT___;
